<template>
  <div class='login'
       v-loading.fullscreen.lock="fullscreenLoading">
    <service :serviceInfo_show='serviceInfo_show'></service>
    <!-- 验证显示找回密码 -->
    <el-dialog title="找回密码"
               :visible.sync="isReset"
               width="40%">
      <div class="retrievePassword">
        <el-form :model="retrievePassword"
                 ref="retrievePassword"
                 label-width="100px"
                 key="retrieve"
                 class="demo-ruleForm">

          <el-form-item label="手机/邮箱"
                        prop="number"
                        :rules="[
      { required: true, message: '手机或者邮箱不能为空'},
    ]">
            <el-input v-model="retrievePassword.number"
                      auto-complete="new-password"
                      placeholder="请输入您的手机号码或者电子邮箱"></el-input>
          </el-form-item>

          <el-form-item label="验证码"
                        prop="code"
                        :rules="[
      { required: true, message: '短信验证码必须填写'},
    ]">
            <el-input v-model="retrievePassword.code"
                      auto-complete="new-password"
                      placeholder="请输入您收到的验证码">
              <el-button type="success"
                         :disabled='resTime!==0'
                         size="mini"
                         @click="countDown(retrievePassword.number)"
                         slot="suffix">{{resTime==0?'发送验证码':resTime+' 秒后重试'}}</el-button>

            </el-input>
          </el-form-item>

          <el-form-item label="新密码"
                        prop="newPW"
                        :rules="[
      { required: true, message: '密码不能为空'},
    ]">
            <el-input v-model="retrievePassword.newPW"
                      type="password"
                      auto-complete="new-password"
                      placeholder="请输入您要更改的密码"></el-input>
          </el-form-item>

          <el-form-item label="重复新密码"
                        prop="repetitionPW"
                        :rules="[{required: true,validator: validatePass}  ]">
            <el-input v-model="retrievePassword.repetitionPW"
                      type="password"
                      auto-complete="new-password"
                      placeholder="请再次输入您要更改的密码"></el-input>
          </el-form-item>

        </el-form>

      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="isReset = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('retrievePassword')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户协议 -->
    <el-dialog title="用户协议"
               class="userProtocol"
               :visible.sync="userProtocol.show"
               width="50%">
      <div class="userProtocol_content"
           ref="userProtocol_content"
           v-html="sysConfig.regxy">

      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">拒 绝</el-button>
        <el-button type="primary"
                   @click="userAffirm()"
                   :disabled='!isRead'>{{!isRead?'请先阅读完协议':'我已阅读且同意'}}</el-button>
      </span>
    </el-dialog>

    <!-- 注册顶部 -->
    <div class="login_top">
      <div class="login_logo">
        <el-image style="width: 80px; height: 80px"
                  :src="sysConfig.logo.url"></el-image>
      </div>
      <div class="login_btn">
        <el-link :underline="false"
                 @click="skipExamine('examinePrice')"
                 target="_blank">点击查价</el-link>
        <el-link :underline="false"
                 @click="skipExamine('logisticsInquer')"
                 target="_blank">物流查询</el-link>
        <el-link :underline="false"
                 @click="skipExamine('notLoginWarehouse')"
                 target="_blank">查询仓库</el-link>
        <el-link :underline="false"
                 @click="serviceInfo_show.flag=true"
                 target="_blank">联系客服</el-link>
      </div>
    </div>
    <!-- 注册内容 -->
    <div class="login_main"
         @keyup.enter="logoin">
      <div class="main_left"></div>
      <div class="loginRegister">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane label="登录"
                       class="login_tab"
                       name="1">
            <el-input v-model="login.userNum"
                      clearable
                      prefix-icon="el-icon-user"
                      placeholder="请输入手机号码/邮箱"></el-input>
            <el-input v-model="login.password"
                      v-if="login.type"
                      key="parssword_input"
                      type="password"
                      prefix-icon="el-icon-key"
                      placeholder="请输入密码"
                      show-password></el-input>
            <el-input v-model="login.code"
                      key="square_input"
                      v-else
                      clearable
                      prefix-icon="el-icon-chat-dot-square"
                      placeholder="请输入短信/邮箱验证码">
              <el-button slot="append"
                         :disabled='resTime!==0'
                         @click="countDown(login.userNum)"
                         class="append_right">{{resTime==0?'发送验证码':resTime+' 秒后重试'}}</el-button>
            </el-input>

            <div class="other_btn">
              <el-link type="primary"
                       @click="isReset=true"
                       :underline="false">忘记密码？</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="login.type=!login.type">{{login.type?'验证码登录':'密码登录'}}</el-link>
            </div>

            <el-button type="primary"
                       class="logoin_btn"
                       @click="logoin">登录</el-button>
          </el-tab-pane>
          <el-tab-pane label="注册"
                       name="2">
            <el-form :model="register"
                     ref="register"
                     label-width="0">
              <!-- 手机号码 -->
              <el-form-item v-if="register.type"
                            prop="userNum"
                            :rules="[
      { required: true, message: '手机号码必须填写'}
    ]">
                <el-input v-model="register.userNum"
                          clearable
                          type="number"
                          prefix-icon="el-icon-mobile"
                          @input="confineNE(register.userNum)"
                          placeholder="请输入手机号码"></el-input>
              </el-form-item>

              <!-- 电子邮箱 -->
              <el-form-item v-else
                            key="emaileitem "
                            prop="emaile"
                            :rules="[
      { required: true, message: '电子邮箱必须填写'},
      { type: 'email', message: '电子邮箱格式错误'}
    ]">
                <el-input v-model="register.emaile"
                          clearable
                          prefix-icon="el-icon-message"
                          placeholder="请输入电子邮箱"></el-input>
              </el-form-item>

              <!-- 短信验证码 -->
              <el-form-item prop="code"
                            :rules="[
      { required: true, message: '验证码必须填写'}
    ]">
                <el-input v-model="register.code"
                          key="square_input"
                          clearable
                          @input="confineNE(register.code)"
                          prefix-icon="el-icon-chat-dot-square"
                          :placeholder="register.type?'请输入短信验证码':'请输入邮箱验证码'">
                  <el-button slot="append"
                             :disabled='resTime!==0'
                             @click="countDown(register.type?register.userNum:register.emaile,register.type?1:2)"
                             class="append_right">{{resTime==0?'发送验证码':resTime+' 秒后重试'}}</el-button>
                </el-input>
              </el-form-item>

              <!-- 密码 -->
              <el-form-item prop="pw"
                            :rules="[
      { required: true, message: '密码必须填写'},
      {min: 6, max: 20,message:'密码长度6-25位'}
    ]">
                <el-input v-model="register.pw"
                          clearable
                          type="password"
                          prefix-icon="el-icon-key"
                          @input="confineNE(register.pw)"
                          show-password
                          auto-complete="new-password"
                          placeholder="请输入密码"></el-input>
              </el-form-item>

              <!-- 重复密码 -->
              <el-form-item prop="rpw"
                            :rules="[
      { required: true,validator:validatePass2}
    ]">
                <el-input v-model="register.rpw"
                          clearable
                          type="password"
                          prefix-icon="el-icon-key"
                          show-password
                          auto-complete="new-password"
                          placeholder="请重复输入密码"></el-input>
              </el-form-item>
            </el-form>
            <div class="other_btn">
              <el-link type="primary"
                       :underline="false"
                       @click="register.type=!register.type">{{register.type?'切换邮箱注册':'切换短信注册'}}</el-link>
              <el-link type="primary"
                       :underline="false"
                       @click="isShowProtocol()">
                <div class="round_view"
                     :class="register.protocol?'active_round_view el-icon-check':''"></div> 用户协议
              </el-link>
            </div>

            <el-button type="primary"
                       :disabled='!register.protocol'
                       @click="register_fn('register')"
                       class="logoin_btn">{{register.protocol?'注册':'请先同意阅读协议'}}</el-button>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="bottomView">
      <div> Copyright @ 2008-2021 {{sysConfig.gsname}} Inc. All Rights Reserved</div>
      <div>备案号：<a href="https://beian.miit.gov.cn/#/Integrated/index">{{Internet_Content_Provider}}</a></div>
    </div>
  </div>
</template>

<script>
import service from '@/components/service'
import { apiSiteInfo, apiGetSystemKey, apiRestPassword, apiMessage, apiSystemInfo, apiUser, apiRegister, apiAccountThere } from '@/request/api'
export default {
  data () {
    return {

      // --------------------备案号--------------------
      Internet_Content_Provider: '粤ICP备2020076811号',
      validatePass2: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.register.pw) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
      validatePass: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.retrievePassword.newPW) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
      // 重置密码
      retrievePassword: {
        number: '',
        code: '',
        newPW: '',
        repetitionPW: '',
      },
      // 用户协议
      userProtocol: {
        show: false,
        content: '',
        title: ''
      },
      // 全局加载动画
      fullscreenLoading: false,
      // 是否显示重置密码界面
      isReset: false,
      // 默认显示的是登录还是注册
      activeName: '1',
      // 登入数据
      login: {
        type: true,
        userNum: '',
        password: '',
        code: ''
      },
      // 注册数据
      register: {
        type: true,
        userNum: '',
        emaile: '',
        code: '',
        pw: '',
        rpw: '',
        protocol: false
      },
      //   发送倒计时
      resTime: 0,
      regTime: 0,
      //   系统配置
      sysConfig: {
        logo: ''
      },
      //   是否已经阅读完成
      isRead: false,
      serviceInfo_show: {
        flag: false
      }
    }
  },
  components: {
    service
  },
  methods: {
    async getSiteInfo () {
      let res = await apiSiteInfo({
        bindhost: location.origin
      })
      this.Internet_Content_Provider = res.info.beanCode
    },

    //   -------------跳转查价-------------
    skipExamine (name) {
      this.$router.push({
        name
      })
    },

    //   -------------登录成功跳转页面-------------
    skipPage (res) {
      // ----------------待优化--------------
      this.$store.commit('upUserInfo', res.userinfo)
      this.$store.commit('upAuthorization', res.token);
      if (res.userinfo) {
        this.$store.commit('setUpUrl');
        this.$store.commit('upName', res.userinfo.realname != '' ? res.userinfo.realname : res.userinfo.mobile)
        this.$store.commit('upUid', res.userinfo.uid)
      }
      // ------------------------------

      if (this.$route.query.redirect) {
        this.$router.push(this.$route.query.redirect);

      } else {
        this.$router.push('/');
      }
    },

    //   -------------注册-------------
    async register_fn (formName) {
      this.fullscreenLoading = true
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await apiRegister({
            username: this.register.type ? this.register.userNum : this.register.emaile,
            password: this.register.code,
            trems: this.register.protocol ? 1 : 0,
            code: 1,
            audit_password: this.register.pw,
            audit_repassword: this.register.rpw,
          })
          if (res.errno == 5000) {
            this.skipPage(res)
          }
        } else {
          return false;
        }
      });
      this.fullscreenLoading = false
    },
    //   -------------登录-------------
    async logoin () {
      this.fullscreenLoading = true
      let res = await apiUser({
        postlogin: 1,
        mode: this.login.type ? 'basic' : 'code',
        username: this.login.userNum,
        password: this.login.type ? this.login.password : this.login.code,
      })
      if (res.errno == 0 || res.errno == 5000) {
        this.$message.success(res.message)
        this.skipPage(res)


      } else {
        this.$message.error(res.message)
      }
      this.fullscreenLoading = false
    },
    //   -------------用户确定重置密码验证-------------
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.fullscreenLoading = true

          let res = await apiRestPassword({
            username: this.retrievePassword.number,
            code: this.retrievePassword.code,
            password: this.retrievePassword.newPW,
            repassword: this.retrievePassword.repetitionPW,
          })
          if (res.errno == 0) {
            this.$message.success(res.message)
            this.isReset = false
          } else {
            this.$message.error(res.message)
          }
          this.fullscreenLoading = false
        } else {
          return false;
        }
      });
    },
    //   -------------用户拒绝协议-------------
    userRefuse () {
      this.userProtocol.show = false
      this.register.protocol = false
    },
    //   -------------用户确认已阅读-------------
    userAffirm () {
      this.userProtocol.show = false
      this.register.protocol = true
    },
    //   -------------判断用户是否已经阅读完用户协议-------------
    menu () {
      let flag = this.$refs.userProtocol_content.scrollTop + 500 == this.$refs.userProtocol_content.scrollHeight
      if (flag && !this.isRead) {
        this.isRead = true
      } else {

      }
    },
    //-------------获取系统配置-------------
    async getSystemInfo () {
      this.fullscreenLoading = true

      let res = await apiSystemInfo({

      })

      if (res.errno == 0) {
        this.sysConfig = res.sysconfig
      }
      this.fullscreenLoading = false
    },
    //-------------显示用户协议-------------
    isShowProtocol () {
      if (this.register.protocol) {
        this.register.protocol = false
      } else {
        this.userProtocol.show = true
        // document.querySelector('.userProtocol_content').addEventListener('scroll', this.menu)
        this.$nextTick(() => {
          this.$refs.userProtocol_content.addEventListener('scroll', this.menu)
        })
      }
    },
    //-------------验证是否为手机号码-------------
    testMobileNum () {
      //   if (/^1[3-9]\d{9}$/.test(this.register.userNum)) {
      //   } else {
      //     return this.$message.error('请输入正确的手机号码')
      //   }
    },
    //-------------限制输入为数、英-------------
    confineNE (e) {
      e = e.replace(/[^\a-\z\A-\Z0-9]/g, '')
    },
    //-------------封装倒计时-------------
    timeCountdown () {
      this.resTime = 60
      let countDownFun = setInterval(() => {
        this.resTime--
        if (this.resTime < 0) {
          clearInterval(countDownFun)
          this.resTime = 0
        }
      }, 1000);
    },
    // -------------发送验证码倒计时-------------
    async countDown (num, falg) {
      this.fullscreenLoading = true
      if (falg) {
        let res = await apiAccountThere({
          find_mode: falg == 1 ? 'mobile' : 'email',
          mobile: num
        })
        if (res.message.errno == 5019) {
          this.fullscreenLoading = false
          return this.$message.error('该手机号已经被注册了')
        }
      }
      if (this.resTime == 0 && num !== '') {
        let res = await apiMessage({
          receiver: num
        })
        if (res.message.errno == 0) {
          this.$message.success(res.message.message)
          this.timeCountdown()

        } else {
          this.$message.error(res.message.message)
        }
      } else {
        if (num == '') {
          this.$message.error('您还未填写手机/邮箱')
        }
      }
      this.fullscreenLoading = false

    },
    //  -------------tab切换回调-------------
    handleClick () {

    }
  },
  created () {
    this.getSystemInfo()
    this.getSiteInfo()
  }
}
</script>

<style lang='scss'>
.login {
  width: 100%;
  height: 100vh;
  min-height: 1000px;
  background: url(https://www.tuanyun99.com/img/pc_img/logoinBGC.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  .userProtocol {
    .userProtocol_content {
      height: 500px;
      overflow: auto;
    }
  }
  .login_top {
    flex: 1;
    width: 100%;
    max-height: 80px;
    // background-color: pink;
    padding: 0 12%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .login_btn {
      .el-link {
        margin: 0 30px;
        font-size: 16px;
      }
    }
  }
  .login_main {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    // background-color: pink;
    .main_left {
      flex: 1;
    }
    .other_btn {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .el-link--inner {
        display: flex;
        align-items: center;
        .active_round_view {
          background-color: #4c90fd !important;
          border-color: #4c90fd !important;
          color: #fff;
          font-weight: 700;
        }
        .round_view {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: #fff;
          border: 1px solid #999;
          margin-right: 7px;
        }
      }
    }
    .logoin_btn {
      margin-top: 40px;
      width: 100%;
    }
    .loginRegister {
      flex: 1;
      padding-top: 10%;
      //   background-color: pink;
      //   margin-left: -10%;
      box-sizing: border-box;
      .el-input-group__append {
        border: 0;
        background-color: #f5f5f5;
      }
      .append_right {
        border: 0;
        background-color: #f5f5f5;
        color: #4c90fd;
      }
      .login_tab {
        .el-input {
          margin-top: 20px;
        }
      }

      .el-tabs {
        width: 530px;
        .el-tabs__content {
          margin-top: 80px;
          input {
            border: 0;
            background-color: #f5f5f5;
            color: #4c90fd;
          }
        }
      }
      .el-tabs__nav-wrap {
        .el-tabs__item {
          font-size: 30px;
        }
        .el-tabs__active-bar {
          height: 4px;
          margin-top: 2px;
        }
      }
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
  }
  .bottomView {
    width: 100%;
    height: 80px;
    // background-color: pink;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999;
    a {
      color: #999;
    }
  }
}
// ftp://tywl99_com@8.129.144.147/img/pc_img/logoinBGC.png
</style>